import { SvgIconProps } from "@mui/material";
import { SignedUpIcon } from "assets/images/onboarding/icons/SignedUpIcon";
import { MailboxIcon } from "assets/images/onboarding/icons/MailboxIcon";
import { TeamMembersIcon } from "assets/images/onboarding/icons/TeamMembersIcon";
import { BrandingIcon } from "assets/images/onboarding/icons/BrandingIcon";
import { CustomersIcon } from "assets/images/onboarding/icons/CustomersIcon";
import { ChannelsIcon } from "assets/images/onboarding/icons/ChannelsIcon";
import { IntegrationsIcon } from "assets/images/onboarding/icons/IntegrationsIcon";

export const STEP_ICON_MAP: Record<
  string,
  React.ComponentType<SvgIconProps>
> = {
  SignedUpIcon,
  MailboxIcon,
  TeamMembersIcon,
  BrandingIcon,
  CustomersIcon,
  ChannelsIcon,
  IntegrationsIcon,
};
